"use client";

import { useEffect } from "react";

import { startLiquidGlass } from "@/app/lib/liquid-glass";

/** Starts the Liquid Glass runtime (bars, Chromium lens) once for the whole app. */
export function GlassRuntime(): null {
  useEffect(() => {
    startLiquidGlass();
  }, []);
  return null;
}
